import { Component, OnInit, HostBinding } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Utils } from '../../utils';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { OrderRs, CancelRs, PositionEnteredRs } from '../../interfaces/service.response';
import { ShareService, ShareProvider } from '../../services/share.service';
import { WorkspaceServiceService } from '../../services/workspace-service.service';

export class PositionEnteredNotificationParams
{
  constructor(public positionEnteredRs: PositionEnteredRs  ){}
}
@Component({
  selector: '[position-entered-notification]',
  template: require('./position-entered-notification.component.html'),
  styles: [require('./position-entered-notification.component.css')],
  animations: [
    trigger('flyInOut', [
        state('inactive', style({
            
            opacity: 0
        })),
        state('active', style({ opacity: 100 })),
        state('removed', style({ opacity: 0 })),
        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ]),
],
preserveWhitespaces: false,
})
export class PositionEnteredNotificationComponent extends Toast implements OnInit 
{
  params: PositionEnteredNotificationParams;

  public get absQuantity()
  {
      return Math.abs(this.params.positionEnteredRs.Quantity);
  }

  public get formattedPrice()
  {
    const boxQuotaData = this.workspaceService.data.boxes.find(b => b.Symbol == this.params.positionEnteredRs.Symbol);
    const decimals = boxQuotaData? boxQuotaData.Decimal: 5;
    return parseFloat(this.params.positionEnteredRs.AvgFillPrice).toFixed(decimals);
  }

  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, public shareService: ShareService, public workspaceService: WorkspaceServiceService) 
  {
    super(toastrService, toastPackage);
    this.params = JSON.parse(Utils.decodeHTMLEntities(this.message as string));
  }

  ngOnInit() {
  }

  public share(provider: string) {
    this.shareService.shareWithSvg(provider, this.getShareText());
  }

  getShareText()
  {
    return Math.random() < 0.5?
     'Going ' + (this.params.positionEnteredRs.Side == 'Sell'? 'SHORT': 'LONG') + ' on the (' + this.params.positionEnteredRs.Symbol + ') NOW using PremiereTrade .  Check it out !!! #PremiereTrade #Forex #ForexTrading':
     'Just went ' + (this.params.positionEnteredRs.Side == 'Sell'? 'SHORT': 'LONG') + ' on the (' + this.params.positionEnteredRs.Symbol + ').. Follow me using PremiereTrade. Check it out !!! #PremiereTrade #Forex #ForexTrading';
  }

  public get Type(){return "" }
  public get Error(){return "" }
}

